export default function dimAcNoFilter2(input) {
	if (input !== undefined)
		return input.substring(0, 4) + " **** **** " + input.substring(input.length - 4);
}


// WEBPACK FOOTER //
// ./src/modules/filter/dimAcNoFilter2.js